import {
  CkBtcMinterCanister,
  MinterAlreadyProcessingError,
  MinterNoNewUtxosError,
} from '@icp-sdk/canisters/ckbtc'
import { Principal } from '@icp-sdk/core/principal'
import { config } from '../appConfig'
import { CKBTC_MINTER_CANISTER_ID } from '../constants/canisterIds'

export const updateCkBTCBalance = async (principalId: string) => {
  const minter = CkBtcMinterCanister.create({
    agent: config.getAgent({ principalId }),
    canisterId: Principal.from(CKBTC_MINTER_CANISTER_ID),
  })

  try {
    return await minter.updateBalance({ owner: Principal.from(principalId) })
  } catch (e) {
    // Both are expected operational states, not failures:
    // - NoNewUtxos: the user has no new BTC deposits to credit.
    // - AlreadyProcessing: another updateBalance is in flight for this user.
    if (e instanceof MinterNoNewUtxosError || e instanceof MinterAlreadyProcessingError) {
      return undefined
    }
    throw e
  }
}
